import { ChartAPIFunctionProps } from '~/types/create.types';

export const drawLine = ({
  data,
  options,
  context,
  domain,
  x,
  y,
}: ChartAPIFunctionProps) => {
  const startIdx = domain[0];
  const firstItem = data[startIdx];
  const x1 = x.xScale(startIdx);
  const y1 = y.yScale(firstItem.value);

  context.strokeStyle = options.colors.line.default;
  context.lineWidth = 2;
  context.beginPath();
  context.moveTo(x1, y1);

  for (let i = startIdx + 1; i <= domain[1]; i++) {
    context.lineTo(x.xScale(i), y.yScale(data[i].value));
  }

  context.stroke();
};
